export default "__VITE_ASSET__VYlPXmJl__"